<template>
	<div class="count card md-elevation-4" style="position: relative; height: 100%">
		<div style="display: flex">
			<div style="margin-top: auto; margin-bottom: auto; padding: 10px; z-index: 10">
				<div>
					<span
						:class="{ title: selected == 0 }"
						@click="selected = 0"
						style="font-size: 24px; cursor: pointer"
						>{{ $t("compiled-documents") }}</span
					>
				</div>
				<div>
					<span
						:class="{ title: selected == 1 }"
						@click="selected = 1"
						style="font-size: 24px; cursor: pointer"
						>{{ $t("total-documents") }}</span
					>
				</div>
			</div>
			<div style="margin-top: auto; margin-bottom: auto; margin-left: auto; margin-right: 0">
				<span style="font-size: 38px">{{ counter }}</span>
			</div>
		</div>
		<div style="width: 100%; display: flex">
			<apexchart
				:key="refresh"
				type="pie"
				height="300"
				ref="pie"
				style="margin-left: auto; margin-right: auto"
				:options="pieOptions"
				:series="pieSerie"
			>
			</apexchart>
		</div>
	</div>
</template>
<script>
import axios from "axios"
export default {
	name: "documents-chart",
	data() {
		return {
			refresh: 0,
			selected: 0,
			pieSerie: [0, 0],
			counter: 0,
			series: [
				{
					name: this.$t("compiled"),
					index_name: "confirmed",
					order: 1,
					data: [0]
				},
				{
					name: this.$t("draft"),
					index_name: "draft",
					order: 0,
					data: [0]
				}
			],
			pieOptions: {
				chart: {
					height: 250,
					type: "pie"
				},
				legend: {
					show: true,
					fontSize: "14px",
					position: "top",
					offsetX: 0,
					offsetY: 5
				},
				labels: [this.$t("draft"), this.$t("compiled")]
			}
		}
	},
	async mounted() {
		var tmp = []
		tmp = await this.retrieveFromApi("/api/documents/getalladmin")

		for (const [index, element] of Object.entries(tmp)) {
			var subitem = this.series.find(subit => {
				return subit.index_name == index
			})
			if (subitem) {
				this.pieSerie[subitem.order] = tmp[index]
				subitem.data = [tmp[index]]
			}
		}

		this.counter = this.pieSerie.reduce((previousValue, currentValue) => previousValue + currentValue)
		this.refresh++
	},

	methods: {
		async retrieveFromApi(urlref) {
			var toreturn = Array(3)
			const payload = {
				pagination: {},
				search: "",
				organization_id: 0
			}

			return await axios
				.post(`${process.env.VUE_APP_API_URL}${urlref}`, payload, {
					headers: {
						Authorization: `Bearer ${localStorage.getItem("JWT")}`
					}
				})
				.then(async res => {
					for (const element of res.data.items) {
						if (toreturn[element.status] === undefined) {
							toreturn[element.status] = 0
						}

						toreturn[element.status]++
					}
					return toreturn
				})
				.catch(() => {})
		}
	}
}
</script>
<style scoped lang="scss">
@import "src/assets/scss/chart.scss";
.tab {
	font-size: 24px;
	margin-top: auto;
	margin-bottom: auto;
	&:hover {
		cursor: pointer;
	}
	margin-left: 5px;
	margin-right: 5px;
}
.title {
	font-weight: 900;
}
</style>
